import request, {requestWithXHRReset} from '../../library/request';
import store from '../../store';
import setGlobalState, {pushToGlobalState} from '../setGlobalState';
import {paginatedRequest} from '../utils/paginatedFetch';

const getVideos = ()=> store.getState().management.videos;
const getVideoRatings = ()=> store.getState().management.videoRatings;

const buildSupportCenterPath = (routeType, id, videoId = null) => {
    const routeMap = {package: 'package', event: 'event'};
    const baseRoute = routeMap[routeType] || 'login';
    const idSegment = id ? `${id}/` : '';
    const videoSegment = videoId ? `/${videoId}` : '';
    return `${baseRoute}/${idSegment}supportCenter${videoSegment}`;
};

export const getSupportVideos = async (pageType, routeType, id, search, onlyCurrentPage = true, limit = 20, offset = 0) => {
    const path = buildSupportCenterPath(routeType, id);
    const res = await request('management.videos', 'get', path, {
        page: pageType,
        search,
        onlyCurrentPage,
        limit,
        offset
    });
    if(res?.videos) {
        if(offset === 0) {
            setGlobalState('management.videos', res.videos);
        } else {
            const videos = getVideos();
            setGlobalState('management.videos', [...videos, ...res.videos]);
        }
        return res.videos.length < limit;
    }
    return true;
};

export const getSupportVideoById = async (videoId, routeType, id) => {
    const path = buildSupportCenterPath(routeType, id, videoId);
    const res = await request('management.videoById', 'get', path);
    return res?.video || null;
};

export const createVideo = async (newVideo)=>{
    const res = await requestWithXHRReset('management.createVideo', 'post', '/management/supportCenter', newVideo);
    if(res?.newVideo)
        setGlobalState('management.videos', [...getVideos(), res.newVideo]);
};
export const editVideo = async (videoId, newVideo)=>{
    const res = await requestWithXHRReset('management.editVideo', 'put', `/management/supportCenter/${videoId}`, newVideo);
    if(res?.newVideo){
        const videos = getVideos();
        const newVideos = videos.map(video=>video.id===newVideo.id?newVideo:video);
        setGlobalState('management.videos', newVideos);
    }
};

export const deleteVideo = async (videoId)=>{
    await requestWithXHRReset('management.deleteVideo', 'delete', `/management/supportCenter/${videoId}`);
    const videos = getVideos();
    setGlobalState('management.videos', videos.filter(video=>video.id!==videoId));
};

export const submitVideoFeedback = async (videoId, rating, text = null) => {
    return await request('management.videoFeedback', 'post', '/user/supportVideoFeedback', {videoId, rating, text});
};

export const incrementVideoViews = async (videoId, routeType, id) => {
    const path = `${buildSupportCenterPath(routeType, id, videoId)}/view`;
    return await request('management.incrementVideoViews', 'post', path);
};
export const getVideoRatingsData = async (limit = 20, offset = 0) => {
    const res = await request('management.videoRatings', 'get', '/management/supportCenter/ratings', {
        limit,
        offset
    });
    if(res?.videoRatings) {
if(offset === 0) {
        setGlobalState('management.videoRatings', res.videoRatings);
        } else { 
            setGlobalState('management.videoRatings', [...getVideoRatings(), ...res.videoRatings]);
}
        return res.videoRatings.length < limit;
    }
    return true;
};

export const resetVideoRatings = () => {
    setGlobalState('management.videoRatings', []);
};


export const getVideoComments = async (videoId) => {
    const videoTitleRef = {value: ''};
    
    const comments = await paginatedRequest(
        async (limit, offset) => {
            const res = await request('management.getVideoComments', 'get', `/management/supportCenter/${videoId}/comments`, {
                limit,
                offset
            });
            // Save videoTitle from first response
            if(res?.videoTitle && !videoTitleRef.value) {
                videoTitleRef.value = res.videoTitle;
            }
            return res;
        },
        'comments',
        'management.videoComments',
        {
            limit: 20,
            offset: 0
        }
    );
    
    return {
        videoTitle: videoTitleRef.value || (comments[0]?.videoTitle || ''),
        comments: comments || []
    };
};